document.addEventListener("DOMContentLoaded", function () {

  // desk landing section carousel
  const liLeftBtn = document.querySelector(
    ".offer-carousel .btn.left"
  );
  const liRightBtn = document.querySelector(
    ".offer-carousel .btn.right"
  );
  const liImagesContainer = document.querySelector(
    ".offer-carousel .offer-carousel-container"
  );
  const lis = document.querySelectorAll(
    ".offer-carousel .offer-carousel-container .card"
  );

  // How much to scroll when clicked on prev/next btn?
  const widthOfLi = document.querySelector(
    ".offer-carousel .offer-carousel-container .card"
  )?.clientWidth;
    
  function updateButtonStates() {
    const maxScrollLeft = liImagesContainer.scrollWidth - liImagesContainer.clientWidth;
  
    // Disable or enable the left button
    if (liImagesContainer.scrollLeft <= 0) {
      liLeftBtn.disabled = true;
      liLeftBtn.classList.add("disabled");
    } else {
      liLeftBtn.disabled = false;
      liLeftBtn.classList.remove("disabled");
    }
  
    // Disable or enable the right button
    if (liImagesContainer.scrollLeft >= maxScrollLeft) {
      liRightBtn.disabled = true;
      liRightBtn.classList.add("disabled");
    } else {
      liRightBtn.disabled = false;
      liRightBtn.classList.remove("disabled");
    }
  }

  let isScrolling = false;

  liImagesContainer.addEventListener("scroll", () => {
    // Debounce logic
    if (isScrolling) return;
    isScrolling = true;
    setTimeout(() => {
      isScrolling = false;
      updateButtonStates(); // Update button states when scrolling ends
    }, 100); // Adjust debounce time as needed
  });

    // hide buttons on just one card
    if(lis.length == 0){
      liRightBtn.classList.add("disabled")
    }

  // Scroll snap to prev/next Lifestyle image according to the btn clicked.
  liLeftBtn.addEventListener("click", () => {
    liImagesContainer.scrollBy({ left: -widthOfLi, behavior: "smooth" });
  });
  liRightBtn.addEventListener("click", () => {
    liImagesContainer.scrollBy({ left: widthOfLi, behavior: "smooth" });
  });


});
